import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface GetNoteSkuRepaymentRequest {
  noteId: string;
  token: string;
  globalFilter: string;
  pagination: any;
  sorting: any;
}

interface FeeDetails {
  totalDue: string;
  paidUp: string;
  balance: string;
}

export interface SKUTransferToOtherSkuDetails {
  senderSku: string;
  currency: string;
  amount: string;
  receiverSku: string;
  date: string;
}

export interface SKUDetails {
  fhAdminFee: FeeDetails;
  fhAddAdminFee: FeeDetails;
  spar: FeeDetails;
  seniorInvestorPrincipal: FeeDetails;
  juniorInvestorPrincipal: FeeDetails;
  seniorInvestorInterest: FeeDetails;
  juniorInvestorInterest: FeeDetails;
  seniorInvestorAddInterest: FeeDetails;
  juniorInvestorAddInterest: FeeDetails;
  acquirerFees: FeeDetails;
  intDiff: FeeDetails;
}

interface Fees {
  fhAdminFee: FeeDetails;
  fhAddAdminFee: FeeDetails;
  spar: FeeDetails;
  seniorInvestorPrincipal: FeeDetails;
  juniorInvestorPrincipal: FeeDetails;
  seniorInvestorInterest: FeeDetails;
  juniorInvestorInterest: FeeDetails;
  seniorInvestorAddInterest: FeeDetails;
  juniorInvestorAddInterest: FeeDetails;
  acquirerFees: FeeDetails;
  intDiff: FeeDetails;
}

export interface GetNoteSkuRepaymentResponse {
  SNLevel: Fees;
  SKULevel: SKUDetails[];
  pagination: PaginationData;
}

export interface PaginationData {
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

const getNoteSkuRepayment = async ({
  token,
  noteId,
  globalFilter,
  pagination,
  sorting,
}: GetNoteSkuRepaymentRequest): Promise<GetNoteSkuRepaymentResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-repayment/structured-note-sku-repayment-detail/${noteId}`,
      {
        params: {
          page: `${pagination.pageIndex * pagination.pageSize}`,
          pageSize: `${pagination.pageSize}`,
          globalFilter: globalFilter ?? "",
          sorting: JSON.stringify(sorting ?? []),
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getNoteSkuRepayment;
